import SHA256 from "crypto-js/sha256"
import Base64 from "crypto-js/enc-base64"
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
export function url(str){
    return str.toLowerCase().replaceAll(" ","-")
}
export function reemplazarAcentos(url) {
  // Reemplazar los códigos URL codificados por caracteres con acento
  return url
    .replace(/%C3%A1/g, 'á')
    .replace(/%C3%A9/g, 'é')
    .replace(/%C3%AD/g, 'í')
    .replace(/%C3%B3/g, 'ó')
    .replace(/%C3%BA/g, 'ú')
    .replace(/%C3%91/g, 'Ñ')
    .replace(/%C3%B1/g, 'ñ');
}
export function encriptar(str){
    return Base64.stringify(SHA256(str))
}
export function toExcel(data,fileName='registros.xlsx'){
    const worksheet=XLSX.utils.json_to_sheet(data)
    const workbook=XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook,worksheet,'Hoja1')
    const buffer=XLSX.write(workbook,{
        bookType:'xlsx',
        type:'array'
    })
    const blob=new Blob([buffer],{
        type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    saveAs(blob,fileName)
}
export function comprobar(str){
    var notrim=str
    str=str.replace(" ","")
    return notrim==str && str.length>=8 && str.toUpperCase()!=str && str.toLowerCase()!=str && /\d/.test(str) && /[^a-zA-Z0-9\s]/.test(str)
}
export function sinacentos_minusculas(str){
    return str.toLowerCase().replaceAll("á","a").replaceAll("é","e").replaceAll("í","i").replaceAll("ó","o").replaceAll("ú","u")
}